import * as THREE from 'three';

const CAMERA_FOV = 75;
const CAMERA_NEAR = 0.1;
const CAMERA_FAR = 100000;
const CAMERA_START_POSITION = [50, 50, 50] as const;

export function initializeCamera(
  parent: HTMLElement,
  scene: THREE.Scene,
): THREE.PerspectiveCamera {
  const camera = new THREE.PerspectiveCamera(
    CAMERA_FOV,
    parent.clientWidth / parent.clientHeight,
    CAMERA_NEAR,
    CAMERA_FAR,
  );
  camera.up.set(0, 0, 1);
  camera.position.set(...CAMERA_START_POSITION);
  scene.add(camera);
  return camera;
}
